import _ from 'lodash';
import { linkShape } from './utils';

export default function navigation() {
  return {
    _id: false,
    type: 'droplet.navigation',
    logo: false,
    logoImg: `${process.env.S3_ASSETS_URL}mock-images/logos/mock-logo.svg`,
    siteSearch: false,
    cartButton: false,
    slideDirection: 'left',
    linkAligned: 'left',
    scrollType: 'none',
    logoAligned: 'left',
    shadow: false,
    links: _.times(2, linkShape()),
    mediaQueries: [
      {
        selector: '.drzNav',
        properties: [
          {
            property: 'background-color',
            desktop: 'rgba(0, 0, 0, 0.5)',
            tablet: 'default',
            mobile: 'default',
          },
        ],
      },
      {
        selector: '.drzNav .drzNav-subLink',
        properties: [
          {
            property: 'background-color',
            desktop: 'default',
            tablet: 'default',
            mobile: 'default',
          },
          {
            property: 'color',
            desktop: 'default',
            tablet: 'default',
            mobile: 'default',
          },
        ],
      },
      {
        selector: '.drzNav .drzNav-link',
        properties: [
          {
            property: 'color',
            desktop: 'default',
            tablet: 'default',
            mobile: 'default',
          },
        ],
      },
      {
        selector: '.drzNav .drzNav-hamburger',
        properties: [
          {
            property: 'color',
            desktop: 'default',
            tablet: 'default',
            mobile: 'default',
          },
        ],
      },
    ],
    navClassList: ['drzNav-links-left'],
    logoClassList: [],
    pageCSS: '',
    bounceDroplet: false,
    activeLink: null,
    isShared: false,
    templateRegion: false,
  };
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/navigation/droplet.schema.js